<div class="content-block">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="content-block">Dashboard </h2>
        <div class="d-flex gap-4">



        </div>
      </div>
    </div>
  </div>
  <!-- Row cards principali -->
  <!--
<div class="row g-3">

  <div class="col-12 col-sm-6 col-md-3 col-lg-2">
    <div class="stat-card">
      <div class="stat-icon bg-blue">
        <i class="fa-solid fa-user-group"></i>
      </div>
      <div class="stat-content">
        <div class="stat-title">Dipendenti</div>
        <div class="stat-value">{{numDipAttivi}}</div>
        <div class="stat-subtitle">attivi</div>
      </div>
    </div>
  </div>


  <div class="col-12 col-sm-6 col-md-3 col-lg-2">
    <div class="stat-card">
      <div class="stat-icon bg-green">
        <i class="fa-solid fa-boxes-stacked"></i>
      </div>
      <div class="stat-content">
        <div class="stat-title">Articoli</div>
        <div class="stat-value">{{numArticoliAttivi}}</div>
        <div class="stat-subtitle">attivi</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-6 col-md-3 col-lg-2">
    <div class="stat-card">
      <div class="stat-icon bg-green">
        <i class="fa-solid fa-boxes-stacked"></i>
      </div>
      <div class="stat-content">
        <div class="stat-title">Sottoscorta</div>
        <div class="stat-value">{{numArticoliSottoscorta}}</div>
        <div class="stat-subtitle">articoli sottoscorta</div>
      </div>
    </div>
  </div>

   <div class="col-12 col-sm-6 col-md-3 col-lg-2">
    <div class="stat-card">
      <div class="stat-icon bg-red">
        <i class="fa-solid fa-boxes-stacked"></i>
      </div>
      <div class="stat-content">
        <div class="stat-title">Esauriti</div>
        <div class="stat-value">{{numArticoliEsauriti}}</div>
        <div class="stat-subtitle">articoli esauriti</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-6 col-md-3 col-lg-2">
    <div class="stat-card">
      <div class="stat-icon bg-yellow">
        <i class="fa-solid fa-boxes-stacked"></i>
      </div>
      <div class="stat-content">
        <div class="stat-title">Consegne in scadenza</div>
        <div class="stat-value">{{numConsegneProssimeAllaScadenza}}</div>
        <div class="stat-subtitle">Consegne in scadenza</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-6 col-md-3 col-lg-2">
    <div class="stat-card">
      <div class="stat-icon bg-red">
        <i class="fa-solid fa-boxes-stacked"></i>
      </div>
      <div class="stat-content">
        <div class="stat-title">Consegne scadute</div>
        <div class="stat-value">{{numConsegneScadute}}</div>
        <div class="stat-subtitle">consegne scadute</div>
      </div>
    </div>
  </div>
</div>
-->



  <div class="row ">
    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px; min-height: 230px; overflow:auto;">

        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted  font-weight-bold" style="font-size: 1.6em;">DIPENDENTI</h2>

          <div id="stockAvailable" class="highlight-number text-muted">{{numDipAttivi}}</div>

          <div class="mini text-muted">attivi</div>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px; min-height: 230px; overflow:auto;">

        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted  font-weight-bold" style="font-size: 1.6em;">ARTICOLI ATTIVI</h2>

          <div id="stockAvailable" class="highlight-number text-muted">{{numArticoliAttivi}}</div>

          <div class="mini text-muted">articoli attivi</div>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px;  min-height: 230px; overflow:auto;" [class]="{
                  'border-warning': numArticoliSottoscorta>0
                }">

        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted  font-weight-bold" style="font-size: 1.6em;">SOTTOSCORTA</h2>

          <div id="stockAvailable" class="highlight-number" [class]="{
                      'text-warning': numArticoliSottoscorta>0,
                       'text-muted': numArticoliSottoscorta==0
                    }">
            {{numArticoliSottoscorta}}
          </div>

          <div class="mini text-muted">articoli sottoscorta</div>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-4" style="border-width: 3px; min-height: 230px; overflow:auto;" [class]="{
                  'border-danger': numArticoliEsauriti > 0
                }">

        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted  font-weight-bold" style="font-size: 1.6em;">ESAURITI</h2>

          <div id="stockAvailable" class="highlight-number" [class]="{
                      'text-danger': numArticoliEsauriti>0,
                      'text-muted': numArticoliEsauriti==0
                    }">
            {{numArticoliEsauriti}}
          </div>

          <div class="mini text-muted">articoli esauriti</div>
        </div>
      </div>
    </div>


    <div class="col-6 col-md-3 col-lg-2">
      <div class="card text-center p-3 border-2" style="border-width: 3px; min-height: 230px; overflow:auto;"
        [class]="{'border-warning' : numConsegneProssimeAllaScadenza > 0, 'border-normal': numConsegneProssimeAllaScadenza <= 0}">
        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.6em;">CONSEGNE IN SCADENZA</h2>
          <div id="usersNearExpiry" class="highlight-number "
            [class]="{'text-warning' :numConsegneProssimeAllaScadenza > 0, 'text-muted': numConsegneProssimeAllaScadenza <= 0}">
            {{numConsegneProssimeAllaScadenza}}</div>
          <div class="mini text-muted">in scadenza entro {{giorniPreAlertArticoli}} giorni</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-12 col-lg-2">
      <div class="card text-center p-3 border-2" style="border-width: 3px; min-height: 230px; overflow:auto;"
        [class]="{'border-danger' : numConsegneScadute > 0, 'border-normal': numConsegneScadute <= 0}">
        <div class="card-body">
          <h2 class="card-subtitle mb-2 text-muted font-weight-bold" style="font-size: 1.6em;">CONSEGNE SCADUTE</h2>
          <div id="usersExpired" class="highlight-number"
            [class]="{'text-danger' :numConsegneScadute > 0,  'text-muted': numConsegneScadute <= 0}">
            {{numConsegneScadute}}</div>
          <div class="mini text-muted">consegne scadute</div>
        </div>
      </div>
    </div>
  </div>



  <!-- Consegne prossime alla scadenza o scadute -->
  <div class="row  mb-3">


    <div class="col-12 col-lg-7">
      <div class="card p-3">
        <h3 class="card-title mb-3 font-weight-bold">Consegne prossime alla scadenza o scadute</h3>
        <div class="table-responsive" style="max-height:280px; overflow:auto;">
          <app-articoli-consegnati-scadenze-compact
            [listConsegneAlert]="listConsegneAlert"></app-articoli-consegnati-scadenze-compact>
        </div>
      </div>
      <div class="card p-3">
        <h3 class="card-title mb-3 font-weight-bold">Consegne da firmare</h3>
        <div class="table-responsive" style="max-height:280px; overflow:auto;">
          <app-dafirmare-grid-view></app-dafirmare-grid-view>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-5">
      <div class="row">
        <div class="col-12 col-lg-6">

          <div class="card p-3">
            <h3 class="card-title mb-3 font-weight-bold">Cerca dipendente</h3>
            <div class="table-responsive" style="max-height:300px; overflow:auto;">
              <dx-lookup [dataSource]="listDipendenti" [displayExpr]="getDisplayExprDipendente" placeholder=""
                [searchExpr]="['codice','nominativo']" [searchEnabled]="true" clearButtonText="Reset"
                showClearButton="true" (onValueChanged)="valueChangedDip($event)">
                <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>

              </dx-lookup>

              <dx-button stylingMode="contained" text="Vai alla scheda del dipendente" icon="search" type="success"
                width="100%" class="mt-1" (onClick)="goToDipendente(selectedEmployee.id)">
              </dx-button>

            </div>
          </div>

        </div>
        <div class="col-12 col-lg-6">

          <div class="card p-3">
            <h3 class="card-title mb-3 font-weight-bold">Cerca articolo</h3>
            <div class="table-responsive" style="max-height:300px; overflow:auto;">
              <dx-lookup [dataSource]="listArticoli" [displayExpr]="getDisplayExprArticolo" placeholder=""
                [searchExpr]="['codice','descrizione']" [searchEnabled]="true" clearButtonText="Reset"
                showClearButton="true" (onValueChanged)="valueChangedDip($event)">
                <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>

              </dx-lookup>

              <dx-button stylingMode="contained" text="Vai alla scheda dell'articolo" icon="search" type="success"
                width="100%" class="mt-1" (onClick)="goToArticolo(selectedEmployee.id)">
              </dx-button>
            </div>
          </div>

        </div>
      </div>




      <div class="card p-3">
        <h3 class="card-title mb-3 font-weight-bold">Articoli sottoscorta/esauriti</h3>
        <div class="table-responsive" style="max-height:370px; overflow:auto;">
          <app-grid-articoli-giacenze-compact [listArticoli]="listArticoliAlert"></app-grid-articoli-giacenze-compact>
        </div>
      </div>


      <div class="card p-3">
        <h3 class="card-title mb-3 font-weight-bold">Scadenze Dipendenti</h3>
        <div class="table-responsive" style="max-height:370px; overflow:auto;">
          <app-grid-scadenze-dipendenti-compact></app-grid-scadenze-dipendenti-compact>
        </div>
      </div>
    </div>
  </div>



</div>